import * as reactI18next from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { Section } from "../section";
import { AssignmentDeliveryDetail } from "./detail";

export interface AssignmentDeliveryProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentDelivery = ({ campaign }: AssignmentDeliveryProps) => {
    const { t } = reactI18next.useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section title={t("campaign_delivery")} isCollapsed={isCollapsed} onClick={toggleCollapse}>
            <AssignmentDeliveryDetail campaign={campaign} />
        </Section>
    );
};
